import { render, staticRenderFns } from "./Translate.vue?vue&type=template&id=e4b13c7c&scoped=true&"
import script from "./Translate.vue?vue&type=script&lang=js&"
export * from "./Translate.vue?vue&type=script&lang=js&"
import style0 from "./Translate.vue?vue&type=style&index=0&id=e4b13c7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4b13c7c",
  null
  
)

export default component.exports